import { jsx as _jsx } from "react/jsx-runtime";
import { Skeleton } from './styles';
export const ProgressiveAssetSkeleton = ({ isVisible, isBlock = false, }) => {
    return _jsx(Skeleton, { animated: true, hasLoaded: !isVisible, isBlock: isBlock });
};
//# sourceMappingURL=ProgressiveAssetSkeleton.js.map